<template>
  <div class="article-filtered-results">
    <ArticleSelectedTagsInfo :tags="loadable.data?.tags_with_news_count ?? []" />

    <div class="results-body">
      <BaseAsyncWrapper :loadable="loadable">
        <template #loading>
          <BaseLoaderWrapper label="Поиск по журналу" width="312px" />
        </template>

        <template #default="{ data: result }">
          <div v-if="result?.items.length" class="news-grid">
            <ArticleMainCard
              v-for="item in result.items"
              :key="item.id"
              :slug="item.slug"
              :name="item.name"
              :image="item.image"
              :published-at="item.publicationDate"
            />
          </div>

          <ArticleEmptyResult v-else />
        </template>
      </BaseAsyncWrapper>
    </div>

    <BasePagination
      v-if="!loadable.isLoading && (loadable.data?.pagination.lastPage ?? 1) > 1"
      class="pagination"
      :base-url="route.fullPath"
      :active-page="loadable.data?.pagination.currentPage ?? 1"
      :total-pages="loadable.data?.pagination.lastPage ?? 1"
    />
  </div>
</template>

<script lang="ts" setup>
  import { BasePagination } from '~/components/base-ui/pagination'
  import { BaseLoaderWrapper } from '~/components/base-ui/loader'
  import { BaseAsyncWrapper } from '~/components/base-ui/async-wrapper'
  import ArticleMainCard from './ArticleMainCard.vue'
  import ArticleSelectedTagsInfo from './ArticleSelectedTagsInfo.vue'
  import ArticleEmptyResult from './ArticleEmptyResult.vue'
  import type ArticleQueryResult from '~/models/articles/article-main/ArticleQueryResult'
  import type { Loadable } from '~/shared/types/loadable'

  defineProps<{
    loadable: Loadable<ArticleQueryResult | null>
  }>()

  const route = useRoute()
</script>

<style lang="scss" scoped>
  .article-filtered-results {
    @extend %flex-column;

    > .pagination {
      margin-top: 32px;

      @include vp-767 {
        margin-top: 24px;
      }
    }
  }

  .results-body {
    @extend %flex-column;

    align-items: center;
    min-height: 200px;

    > .news-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 20px;

      @include vp-1279 {
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
      }

      @include vp-767 {
        grid-template-columns: 1fr;
      }
    }
  }
</style>
